import React from "react";

// Feature data
const features = [
  {
    icon: "bx-money",
    title: "Best Price Guarantee",
    desc: "SRS Cab Service offers affordable and transparent pricing for all city and outstation rides.",
  },
  {
    icon: "bx-map",
    title: "Doorstep Pickup",
    desc: "Get picked up right from your home, hotel, or airport with our reliable cab service.",
  },
  {
    icon: "bxs-car",
    title: "Well-Maintained Fleet",
    desc: "Travel in clean, comfortable, and regularly serviced vehicles for a smooth journey.",
  },
  {
    icon: "bx-support",
    title: "24/7 Customer Support",
    desc: "Our support team is always available to assist you with bookings and travel queries.",
  },
];

const FeatureSection = () => {
  return (
    <section className="feature-section bhg pt-0">
      {/* Add Boxicons CDN */}
      <link
        href="https://unpkg.com/boxicons@2.1.4/css/boxicons.min.css"
        rel="stylesheet"
      />

      <div className="container">
        <div className="row align-items-center">

          {/* Left Side */}
          <div className="col-lg-6">
            <div className="feature-img">
              <div className="section-heading heading-four text-start" data-aos="fade-down">
                <h2>Why Choose SRS Cab Service?</h2>
                <p>
                  We provide safe, reliable, and affordable cab services for city travel,
                  airport transfers, and outstation trips. Experience comfort and convenience with every ride.
                </p>
              </div>
              <img
                // src="/images/fleet/Toyota-Innova.jpg"
                src="/images/bg.png"
                alt="SRS Cab Service"
                className="img-fluid"
              />
            </div>
          </div>

          {/* Right Side */}
          <div className="col-lg-6">
            <div className="row row-gap-4">
              {features.map((feature, index) => (
                <div key={index} className="col-md-6 d-flex">
                  <div className="feature-item flex-fill">
                    <span className="feature-icon">
                      <i className={`bx ${feature.icon}`}></i>
                    </span>
                    <div>
                      <h6 className="mb-1">{feature.title}</h6>
                      <p>{feature.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default FeatureSection;